module.exports = __webpack_public_path__ + "static/media/Tmovimiento-01.effcc671.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/fuel/Tmovimiento-01.svg
// module id = 705
// module chunks = 0